"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Snapcode = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
// eslint-disable-next-line css-modules/no-unused-class
const Snapcode_module_css_1 = __importDefault(require("./Snapcode.module.css"));
/**
 * Snapcode
 */
function Snapcode({ snapcodeImageUrl, size, alt }) {
    return ((0, jsx_runtime_1.jsx)("img", { src: snapcodeImageUrl, "data-testid": "snapCodeImage", className: Snapcode_module_css_1.default[size], alt: alt }));
}
exports.Snapcode = Snapcode;
//# sourceMappingURL=Snapcode.js.map